import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';

// PER ORA STO SERVIZIO NON VIENE USATO DIRETTAMENTE DALLE PAGINE, VIENE SOLO CHIAMATO IL CREATE ALL'AVVIO DELL'APP
// ANDREBBERO IMPLEMENTATE LE FUNZIONI E CHIAMATE IN OGNUNA DELLE PAGINE
@Injectable({
  providedIn: 'root'
})
export class StorageService {
  private _storage: Storage;

  constructor(private storage: Storage) {
    this.storage.create();
    this._storage = storage;
  }

  public async set(key: string, value: any) {
    await this._storage.set(key, value);
  }

  public get(key: string) {
    return this._storage.get(key);
  }

  public remove(key: string) {
    this._storage.remove(key);
  }
}
